module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiCn.f9508d7.woff";